import { useContext } from "react";
import { useSelector } from "react-redux";

import { DEMO_CLIENT_ID } from "../config";
import { AuthContext } from "../providers/authProvider";

const useAuth = () => {
  const {
    user,
    login,
    logout,
    token,
    error,
    isLoading,
    isLoginLoading,
    linkToken,
    setLinkToken,
    linkAccessData,
    linkTokenLevel,
  } = useContext(AuthContext);

  const isDemo = useSelector(
    (state) => state.auth?.me?.clientId === DEMO_CLIENT_ID,
  ); //linkToken && linkToken === DEMO_TOKEN && token == null;

  const isTechnician = useSelector((state) => state.auth?.me?.isTechnician);

  const isAdmin = !!token;
  const hasLinkAccess = !!linkToken;

  return {
    user,
    login,
    logout,
    token,
    error,
    isLoading,
    isLoginLoading,
    linkToken,
    setLinkToken,
    linkAccessData,
    linkTokenLevel,
    isTechnician,
    isAdmin,
    hasLinkAccess,
    isDemo,
  };
};

export default useAuth;
